'use strict';

angular.module('amexReconciliationApp')
  .service('PreviouslyUsedAccountingFieldValuesRepository', function ($resource) {
    var self = this;
    var findBySiteNumberResource = $resource('/api/v1/accounting_field_values/search/previously_used');
    var deleteBySiteNumberResource = $resource('/api/v1/accounting_field_values/delete/previously_used');

    self.findBySiteNumber = function (siteNumber) {
      return findBySiteNumberResource.query({siteNumber: siteNumber}).$promise;
    };

    self.deleteBySiteNumber = function (siteNumber) {
      return deleteBySiteNumberResource.delete({siteNumber: siteNumber}).$promise;
    };
    
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/PreviouslyUsedAccountingFieldValuesRepository.js
// module id = 616
// module chunks = 0